// Privacy in brief: what Fellowship keeps and why, in plain sentences, with the full notice on
// biblestandard.app. Every line is a fact the product already holds itself to (PRODUCT.md, Settings).
import { createFileRoute } from "@tanstack/react-router";
import { StaticHead, StaticPage, staticStyles as s } from "../components/StaticPage";
import { useTitle } from "../lib/useTitle";
import r from "./static.module.css";

export const Route = createFileRoute("/privacy")({ component: Privacy });

const FACTS: [string, string][] = [
  ["Your account", "Your email (to send sign-in codes), your handle, your name, and your photo and a line about you if you add them."],
  ["Your age", "Your date of birth is never stored. We keep only that you are 13 or over."],
  ["What you share", "Posts, comments, responses and saves, seen by your friends only. There are no followers and no public feed."],
  ["Your notes", "Highlights, notes and bookmarks are kept on every device you sign in to, and notes are encrypted on our servers."],
  ["No tracking", "Fellowship runs no analytics, and its fonts and images are served by us, not by other companies."],
  ["Your choice", "Download everything we hold from Settings at any time. Deleting your account removes it straight away; backups clear within 30 days."],
];

function Privacy() {
  useTitle("Privacy");
  return (
    <StaticPage>
      <StaticHead
        title={
          <>
            Privacy, <em>in brief.</em>
          </>
        }
        lead={
          <>
            What Fellowship keeps, and why. The full notice is at <a href="https://biblestandard.app/privacy">biblestandard.app/privacy</a>.
          </>
        }
      />
      <dl className={s.terms}>
        {FACTS.map(([term, line]) => (
          <div key={term}>
            <dt>{term}</dt>
            <dd>{line}</dd>
          </div>
        ))}
      </dl>
      <p className={`${s.prose} ${r.after}`}>
        Questions about your data go to <a href="mailto:fellowship@biblestandard.app">fellowship@biblestandard.app</a>.
      </p>
    </StaticPage>
  );
}
